import { getImageUrl } from '@/utils/api';

// Per-image notes table mirroring the SGI portal's "Images Uploaded" layout
// (Image · Notes · Date). Renders `task.image_notes` — a list of
// { image_url, notes, captured_at } populated by the SGI importer.
//
// Falls back gracefully:
//   - rows with no notes / no date still render (cell shows em-dash)
//   - rows whose image_url failed to download show a broken-image placeholder
export function ImagesUploadedTable({ entries, title = 'Images Uploaded' }) {
  if (!entries || entries.length === 0) return null;

  const fmtDate = (s) => {
    if (!s) return '—';
    // Try ISO-8601 first; fall back to the raw string SGI emits.
    const d = new Date(s);
    if (!isNaN(d.getTime())) return d.toLocaleString();
    return s;
  };

  return (
    <div className="overflow-x-auto border border-border rounded-lg" data-testid="images-uploaded-table">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 border-b border-border">
          <tr>
            <th className="text-left px-3 py-2 text-xs font-semibold text-slate-700 w-[180px]">Image</th>
            <th className="text-left px-3 py-2 text-xs font-semibold text-slate-700">Notes</th>
            <th className="text-left px-3 py-2 text-xs font-semibold text-slate-700 w-[140px]">Date</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {entries.map((row, i) => {
            const src = getImageUrl(row.image_url);
            return (
              <tr key={`${row.image_url}-${i}`} className="align-top">
                <td className="px-3 py-2">
                  {src ? (
                    <a href={src} target="_blank" rel="noreferrer" className="block">
                      <img
                        src={src}
                        alt={row.notes ? row.notes.slice(0, 40) : `Image ${i + 1}`}
                        className="w-40 h-40 object-contain bg-slate-50 rounded border border-border hover:ring-2 hover:ring-blue-300 transition-all"
                        loading="lazy"
                        onError={(e) => { e.target.style.opacity = '0.3'; }}
                      />
                    </a>
                  ) : (
                    <div className="w-40 h-40 bg-slate-100 rounded border border-border flex items-center justify-center text-xs text-muted-foreground">No image</div>
                  )}
                </td>
                <td className="px-3 py-2 whitespace-pre-wrap text-foreground leading-relaxed">
                  {row.notes ? row.notes : <span className="text-muted-foreground italic">No notes</span>}
                </td>
                <td className="px-3 py-2 text-xs text-muted-foreground whitespace-nowrap">{fmtDate(row.captured_at)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
